import React from 'react';
import { Box } from '@match/react-component-library';
import { ContainerQueryProps } from '../components/ContainerQuery/ContainerQueryProvider';
import withContainerQuery from '../components/ContainerQuery/withContainerQuery';
// import Header from './Header';
// import styles from './PageLayout.module.css';
import { DesktopLayout } from './DesktopLayout';
import { MobileLayout } from './MobileLayout';

interface PageLayoutProps {
  children: React.ReactNode;
  dark?: boolean;
}

const PageLayout: React.FC<PageLayoutProps & ContainerQueryProps> = ({
  children,
  dark,
  device
}) => {
  console.log('d', dark, device);
  return (
    <Box
      height="100%"
    >
      {device.desktop && (
        <DesktopLayout dark={!!dark}>
          {children}
        </DesktopLayout>
      )}
      {device.mobile && (
        <MobileLayout dark={!!dark}>
          {children}
        </MobileLayout>
      )}
    </Box>
  );
};

export default withContainerQuery(PageLayout);

/*
<Box
      minHeight="100%"
      display="flex"
      justifyContent="start"
      flexDirection="column"
      alignItems="center"
      backgroundColor={dark ? 'ctaPrimary' : 'light'}
    >
      <Header device={device} dark={dark} />
      {withBackground && (
        <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/bkg@2x.png)` }} className={styles.desktop_background}>
          <Box
            minHeight="100%"
            width="100%"
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
          >
            {children}
          </Box>
        </div>
      )}
      {!withBackground && (
        <Box
          alignItems="center"
          display="flex"
          flex="1"
          flexDirection="column"
          justifyContent="center"
          minHeight="100%"
          width="100%"
        >
          {children}
        </Box>
      )}
    </Box>
    */